module.exports = __webpack_public_path__ + "static/demoImage-4d6d11caca24e1c9565ead6ec053a64e.png";